var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.toAddProductPage}},[_vm._v(" Add Product ")])])}
var staticRenderFns = []

export { render, staticRenderFns }